enum AdswizzReportRequest {
  Date = 'BID_DAY',
  DeviceType = 'DEVICE_TYPE',
  Publisher = 'PUBLISHER',
  DayTime = 'DAYTIME',
  Campaign = 'CAMPAIGN',
  Order = 'ORDER',
  Advertiser = 'ADVERTISER',
  Creative = 'CREATIVE',
  Deals = 'DEALS',
  DmaGeo = 'DMA_GEO',
  ZipGeo = 'ZIP_GEO',
  ZipByCodes = 'ZIP_BY_CODES',
  DmaBoundaries = 'DMA_BOUNDARIES',
  StateBoundaries = 'STATE_BOUNDARIES',
  CountyBoundaries = 'COUNTY_BOUNDARIES',
  CongressionalBoundaries = 'CONGRESSIONAL_BOUNDARIES',
  Genre = 'GENRE',
}

export default AdswizzReportRequest;
